import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown, ArrowRight, Mail, Calendar } from 'lucide-react';
import Reveal from '../components/Reveal';
import { faqData, bookingUrl } from '../data/mock';

const FaqItem = ({ item, index, isOpen, onToggle }) => (
  <div className={`bg-[#fbf9f5] border ${isOpen ? 'border-[#ff7300]' : 'border-black/10'} transition-colors`} data-testid={`faq-item-${index}`}>
    <button onClick={onToggle} aria-expanded={isOpen} className="w-full flex items-center justify-between gap-6 px-6 py-5 text-left">
      <span className="flex items-center gap-5">
        <span className="font-serif text-2xl text-[#ff7300]">{String(index + 1).padStart(2, '0')}</span>
        <span className="font-medium text-[#010c23] text-base md:text-lg">{item.q}</span>
      </span>
      <ChevronDown size={20} className={`flex-shrink-0 text-[#010c23]/60 transition-transform duration-300 ${isOpen ? 'rotate-180 text-[#ff7300]' : ''}`} />
    </button>
    {isOpen && (<p className="px-6 pb-6 pl-[76px] text-[#010c23]/75 leading-relaxed animate-fade-in justify-text">{item.a}</p>)}
  </div>
);

const TABS = [
  { id: 'ometis', label: 'Le cabinet' },
  { id: 'av', label: 'Assurance-vie' },
  { id: 'per', label: 'PER' },
  { id: 'scpi', label: 'SCPI' }
];

const FaqHero = () => (
  <section className="pt-40 pb-16 bg-[#010c23] text-white">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
      <Reveal>
        <div className="flex items-center gap-3 mb-6">
          <span className="h-px w-14 bg-[#ff7300]" />
          <span className="text-[11px] tracking-[0.35em] uppercase text-[#ff7300] font-medium">Foire aux questions</span>
        </div>
        <h1 className="font-serif text-5xl md:text-7xl font-light leading-tight max-w-4xl">
          Vos questions, <span className="italic text-[#ff7300]">nos réponses</span>
        </h1>
      </Reveal>
    </div>
  </section>
);

const FaqTabs = ({ active, onSelect }) => (
  <section className="sticky top-[80px] md:top-[100px] z-30 bg-white border-b border-black/5">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
      <div className="flex gap-1 overflow-x-auto">
        {TABS.map((t) => (
          <button key={t.id} onClick={() => onSelect(t.id)} data-testid={`faq-tab-${t.id}`} className={`px-6 md:px-10 py-5 text-sm tracking-widest uppercase font-medium transition-colors border-b-2 whitespace-nowrap ${active === t.id ? 'border-[#ff7300] text-[#010c23]' : 'border-transparent text-[#010c23]/50 hover:text-[#010c23]'}`}>
            {t.label}
          </button>
        ))}
      </div>
    </div>
  </section>
);

const FaqCta = () => (
  <div className="mt-16 p-10 bg-[#010c23] text-white text-center">
    <h3 className="font-serif text-3xl font-light">Une question spécifique à votre situation ?</h3>
    <p className="mt-4 text-white/80">Chaque situation est unique. Discutons-en directement.</p>
    <div className="mt-8 flex flex-wrap justify-center gap-4">
      <a href={bookingUrl} target="_blank" rel="noreferrer" className="btn-primary"><Calendar size={18} /> Prendre rendez-vous en ligne</a>
      <Link to="/contact" className="btn-outline">Nous contacter <Mail size={16} /></Link>
    </div>
  </div>
);

const FAQ = () => {
  const [active, setActive] = useState('ometis');
  const [openIdx, setOpenIdx] = useState(0);
  const current = faqData[active];
  const selectTab = (id) => { setActive(id); setOpenIdx(0); };

  return (
    <div>
      <FaqHero />
      <FaqTabs active={active} onSelect={selectTab} />
      <section className="py-20 bg-white">
        <div className="max-w-[1000px] mx-auto px-6 lg:px-12">
          <div className="mb-12">
            <div className="section-label mb-3"><span className="divider-gold"></span>{current.subtitle}</div>
            <h2 className="font-serif text-4xl md:text-5xl text-[#010c23] font-light">{current.title}</h2>
          </div>
          <div className="space-y-3">
            {current.items.map((item, idx) => (
              <FaqItem key={item.q} item={item} index={idx} isOpen={openIdx === idx} onToggle={() => setOpenIdx(openIdx === idx ? -1 : idx)} />
            ))}
          </div>
          <FaqCta />
        </div>
      </section>
    </div>
  );
};

export default FAQ;
